<svelte:options tag={null} />

<script lang="typescript">
  import "@everymatrix/em-card/dist/em-card";
  import { dispatchWcEvent, getHeaders, isPermissionPresent } from '@everymatrix/retail-helpers';
  import { get_current_component } from "svelte/internal";
  import type { PlayerRolesResponse, Role } from "./PlayerRolesCard.models";
 
	export let src: string;
  export let playerid: string;
  export let maxheight: string = 'none'; 

  let playerRoles: Role[];
  let isLoading = false;
  let errorMessage: string;
  let permissions;
  permissions = {};

  const thisComponent = get_current_component();

  const fetchPlayerRoles = async (src: string) => {
    try {
      isLoading = true;
      errorMessage = null;
      const headers = await getHeaders();
      const res = await fetch(src, { headers });
      const {total, items}:PlayerRolesResponse = await res.json();
      if (res.ok) {
        if(total <= 10) {
          playerRoles = [...items];
          return;
        }
        const endpoint = new URL('', src);
        endpoint.searchParams.append('pagination', `limit=${total},offset=10`);
        const response = await fetch(endpoint.href, {headers});
        const data = await response.json();
        playerRoles = [...items, ...data.items]
      }else {
        throw new Error("Failed to get player roles")
      }
    } catch (err) {
      errorMessage = "Could not get player roles"
      console.error(err);
    } finally {
      isLoading = false;
    }
  };

  const getPemissions = async () => {
    permissions.canWriteRoles = await isPermissionPresent(src, 'upp.nav.roles', 'READ');
  }

  $: src && getPemissions();
  $: src && playerid &&  fetchPlayerRoles(`${src}${playerid}/playerRoles`);
</script>

<em-card>
  <!-- Header -->
  <h3 slot="header">
    Player Roles
  </h3>

  <!-- Content -->
  <div slot="content">
    {#if isLoading}
      <ul class="loader">
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
      </ul>
    {:else if playerRoles}
      {#if playerRoles.length === 0}
        <p>You don't have any active roles on this user</p>
      {/if}
       <ul style="max-height:{maxheight}; overflow:auto;">
          {#each playerRoles as playerRole}
            <li>
              <span>
                {playerRole.roleName}
              </span>
            </li>
          {/each}
        </ul>
      {#if permissions.canWriteRoles}
      <div class="button-wrapper">
        <button on:click="{() => dispatchWcEvent(thisComponent, 'navigate' , "player-roles-page")}">
          Manage Roles
        </button>
      </div>
      {/if}
    {:else}
      <p class="error">{errorMessage}</p>
    {/if}
  </div>
</em-card>

<style lang="scss">
  *,
  *::before,
  *::after {
    margin: 0;
    padding: 0;
    list-style: none;
    outline: none;
    text-decoration: none;
    box-sizing: border-box;
    font-family: "Helvetica Neue", "Helvetica", sans-serif;
  }

  li {
    display: grid;
    padding: 5px;
    grid-template-columns: auto 1fr;
    margin-bottom: 10px;
    &:last-child { margin-bottom: 0; }

    strong { margin-right: 10px; }

    span { align-self: flex-end; }
  }

  // Text Loader
  .loader {
    min-width: 200px;

    li {
      position: relative;
      height: 18px;
      margin-bottom: 10px;
      animation-duration: 1.25s;
      animation-fill-mode: forwards;
      animation-iteration-count: infinite;
      animation-name: shimmer;
      animation-timing-function: linear;
      background: #f6f6f6;
      background: linear-gradient(
        to right,
        #f6f6f6 8%,
        #f0f0f0 18%,
        #f5f5f5 33%
      );
      background-size: 800px 104px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .button-wrapper {
    margin-top: 15px;
  }
  button {
    width: 100%;
    min-height: 30px;
    padding: 6px 7px;
    color: #fff;
    background: #307fe2;
    border: 1px solid #307fe2;
    border-radius: 3px;
    font-weight: 700;
    text-transform: uppercase;
    line-height: 16px;
    &:hover {
      background: #000;
      border: 1px solid #000;
    }
  }

  // Animation
  @keyframes shimmer {
    0% {
      background-position: -468px 0;
    }
    100% {
      background-position: 468px 0;
    }
  }
</style>
